export default function formatChf(number) {
  return Number(number).toLocaleString(
    'fr-CH',
    { style: 'currency', currency: 'CHF' });
}
